var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-main-container" }, [
    _c("div", { staticClass: "card setting-card" }, [
      _c("div", { staticClass: "page-header" }, [
        _c("h3", { staticClass: "page-title" }, [
          _vm._v(_vm._s(_vm.$t("funders.basic_info"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("funders.display_name"))),
          ]),
          _vm._v(" "),
          _vm.viewFunder && _vm.viewFunder.name != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewFunder.name))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("funders.primary_contact_name"))),
          ]),
          _vm._v(" "),
          _vm.viewFunder && _vm.viewFunder.contact_name != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewFunder.contact_name))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("funders.email"))),
          ]),
          _vm._v(" "),
          _vm.viewFunder && _vm.viewFunder.email != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewFunder.email))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("funders.phone"))),
          ]),
          _vm._v(" "),
          _vm.viewFunder && _vm.viewFunder.phone != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewFunder.phone))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("funders.primary_currency"))),
          ]),
          _vm._v(" "),
          _vm.viewFunder && _vm.viewFunder.currency != null
            ? _c("p", [
                _vm._v(
                  _vm._s(_vm.viewFunder.currency.code) +
                    "-" +
                    _vm._s(_vm.viewFunder.currency.name)
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("funders.website"))),
          ]),
          _vm._v(" "),
          _vm.viewFunder && _vm.viewFunder.website != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewFunder.website))])
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }